import React, { useContext, useEffect } from "react";
import ReactDOM from "react-dom";
import styled, { keyframes } from "styled-components";
import { ReactComponent as CloseSVG } from "./close.svg";

const Context = React.createContext();

export function OverlayProvider({ children }) {
  const overlayRef = React.useRef();
  const openState = React.useState(false);
  const [isOpen, setIsOpen] = openState;
  const [overlayNode, setOverlayNode] = React.useState();

  // make sure re-render is triggered after initial
  // render so that ref exists
  useEffect(() => {
    setOverlayNode(overlayRef.current);
  }, []);

  return (
    <>
      <Context.Provider value={{ overlayNode, openState }}>
        <Content isOpen={isOpen}>{children}</Content>
      </Context.Provider>
      <div ref={overlayRef} />
    </>
  );
}

export default function Overlay({ onClose, children, ...props }) {
  const { overlayNode, openState } = useContext(Context);
  const [isOpen, setIsOpen] = openState;

  useEffect(() => {
    setIsOpen(true);
    const handleEsc = (event) => {
      if (event.keyCode === 27) if (onClose) onClose();
    };
    window.addEventListener("keydown", handleEsc);
    return () => {
      window.removeEventListener("keydown", handleEsc);
      setIsOpen(false);
    };
  }, []);

  const handleOnClick = (event) => {
    // event.preventDefault();
    if (onClose) onClose();
  };

  const closeBtn = (
    <CloseSVG
      style={{
        position: `absolute`,
        top: 10,
        right: 20,
        height: `2rem`,
        width: `2rem`,
        zIndex: `101`,
        cursor: `pointer`,
      }}
      onClick={() => {
        if (onClose) onClose();
      }}
    ></CloseSVG>
  );

  return overlayNode
    ? ReactDOM.createPortal(
        <Container onClick={handleOnClick}>
          {isOpen && closeBtn}
          {children}
        </Container>,
        overlayNode
      )
    : null;
}

const fadeIn = keyframes`from { opacity: 0; }`;

const Content = styled.div`
  ${({ isOpen }) =>
    isOpen &&
    `
    filter: blur(5px);
    -webkit-filter: blur(5px);
  `}
`;

const Container = styled.div`
  animation: ${fadeIn} 200ms ease-out;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
`;
